/**
 * Cleans raw email body / HTML into natural spoken text (read-only V1.5).
 */

function decodeBasicEntities(text) {
  return String(text || "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/&apos;/gi, "'");
}

function stripHtml(html) {
  return String(html || "")
    .replace(/<style[\s\S]*?<\/style>/gi, " ")
    .replace(/<script[\s\S]*?<\/script>/gi, " ")
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/(p|div|tr|li|h[1-6])>/gi, "\n")
    .replace(/<[^>]+>/g, " ")
    .replace(/\r\n/g, "\n");
}

function stripQuotedReplies(text) {
  const lines = String(text || "").split("\n");
  const kept = [];
  for (const line of lines) {
    const trimmed = line.trim();
    if (/^on .+ wrote:$/i.test(trimmed)) {
      break;
    }
    if (/^-{2,}\s*original message\s*-{2,}$/i.test(trimmed)) {
      break;
    }
    if (/^from:\s.+/i.test(trimmed) && kept.length > 0) {
      // Likely the start of a forwarded / quoted header block.
      break;
    }
    if (/^>/.test(trimmed)) {
      continue;
    }
    kept.push(line);
  }
  return kept.join("\n");
}

function stripCommonSignatures(text) {
  const lines = String(text || "").split("\n");
  const cutAt = lines.findIndex((line) => {
    const trimmed = line.trim();
    if (trimmed === "--" || trimmed === "—") {
      return true;
    }
    if (/^sent from my (iphone|ipad|android)/i.test(trimmed)) {
      return true;
    }
    if (/^get outlook for /i.test(trimmed)) {
      return true;
    }
    if (/^confidentiality notice/i.test(trimmed)) {
      return true;
    }
    return false;
  });
  if (cutAt >= 0) {
    return lines.slice(0, cutAt).join("\n");
  }
  return text;
}

/**
 * @param {string} rawBody
 * @returns {string}
 */
export function prepareEmailBodyForSpeech(rawBody) {
  let text = stripHtml(rawBody);
  text = decodeBasicEntities(text);
  text = stripQuotedReplies(text);
  text = stripCommonSignatures(text);
  text = text
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .replace(/[ \t]{2,}/g, " ")
    .trim();
  return text;
}

/**
 * First 1–2 sentences (or char budget) for a richer spoken summary.
 * @param {string} cleanedBody
 * @param {number} [maxChars]
 */
export function takeSpokenExcerpt(cleanedBody, maxChars = 280) {
  const text = String(cleanedBody || "").replace(/\s+/g, " ").trim();
  if (!text) {
    return "";
  }
  if (text.length <= maxChars) {
    return text;
  }

  const sentenceMatch = text.match(/^(.+?[.!?])(?:\s+|$)/);
  let excerpt = sentenceMatch ? sentenceMatch[1] : text.slice(0, maxChars);
  if (excerpt.length < 80) {
    const second = text.slice(excerpt.length).match(/^(.+?[.!?])(?:\s+|$)/);
    if (second) {
      excerpt = `${excerpt} ${second[1].trim()}`;
    }
  }
  if (excerpt.length > maxChars) {
    const sliced = excerpt.slice(0, maxChars);
    const lastSpace = sliced.lastIndexOf(" ");
    excerpt = (lastSpace > 40 ? sliced.slice(0, lastSpace) : sliced).trim();
    if (!/[.!?]$/.test(excerpt)) {
      excerpt = `${excerpt}…`;
    }
  }
  return excerpt.trim();
}
